// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowRightToLine16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-right-to-line': IconArrowRightToLine;
    }
}

/**
 * The icon component for the 'arrowRightToLine' icon
 */
export class IconArrowRightToLine extends IconSvg {
    public constructor() {
        super(arrowRightToLine16X16);
    }
}

registerIconSvg('icon-arrow-right-to-line', IconArrowRightToLine);
export const iconArrowRightToLineTag = 'nimble-icon-arrow-right-to-line';
